<template>
  <div>
    <div style="margin-left: 30px" class="text-danger">
      如欲修改，建議於營業時間結束後修改營業時間設定，避免影響現行門市接單計算，謝謝
    </div>
    <div id="func-content">
        <b-card class="bg-default-card">
            <div class="row p-4">
                <label class="col-md-2" style="text-align:right">品牌：</label>
                <div class="col-md-2">
                    <select
                          id="brands-code"
                          name="brandsCode"
                          class="form-control"
                          v-model="search.brandCode"
                        >
                        <option
                          v-for="x in selectListBrands"
                          v-bind:value="x.Code"
                          :key="x.Code"
                        >{{x.Text}}</option>
                    </select>
                </div>
            </div>
            <div class="row px-4 pb-4">
                <label class="col-md-2" style="text-align:right">店號：</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="search.code" placeholder="請輸入店號">
                </div>
                <label class="col-md-2" style="text-align:right">店名：</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="search.name" placeholder="模糊搜尋">
                </div>
                <div class="col-md-3" style="text-align:right">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                </div>
            </div>
        </b-card>
        <b-card class="bg-default-card">
            <div class="row">
                <div class="table-responsive">
                    <table class="table table-bordred table-striped">
                        <thead>
                            <tr>
                            <th>項次</th>
                            <th>品牌</th>
                            <th>店號</th>
                            <th>店名</th>
                            <th>平日營業時間</th>
                            <th>假日營業時間</th>
                            <th>備餐時間</th>
                            <th>臨時備餐時間</th>
                            <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                            <td>{{pageRows * (search.currentPage - 1) + index + 1}}</td>
                            <td>{{x.brandCode}}</td>
                            <td>{{x.code}}</td>
                            <td>{{x.name}}</td>
                            <td>{{x.weekdayStartTime=='' ? '' : x.weekdayStartTime + '~' + x.weekdayEndTime}}</td>
                            <td>{{x.holidayStartTime=='' ? '' : x.holidayStartTime + '~' + x.holidayEndTime}}</td>
                            <td>{{x.productionTime}}</td>
                            <td>{{x.tempProductionTime}}</td>
                            <td>
                                <button class='btn-circle btn-circle-ptc1' v-show='FunctionPermission > 1' @click="editByOpen(x)"><span class='fas fa-pencil-alt' title="編輯營業時間"></span></button>
                                <button v-b-tooltip.hover.top title="刪除營業時間" class="btn-circle btn-circle-ptc1" @click="showDelete(x)" v-if="FunctionPermission > 1"><span class="fas fa-trash-alt"></span></button>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row" style="padding: 0 1rem">
                    <b-pagination size="md" :total-rows="totalRows" v-model="search.currentPage" :per-page="pageRows" @change="changePage"></b-pagination>
                    <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                </div>
            </div>
        </b-card>
        <b-modal ref="mdEdit" :no-close-on-backdrop="true" hide-footer title="修改門市營業時間" size="lg">
            <div class="d-block">
                <div class="col-lg-12 col-12 mb-3">
                    <div class="row col-lg-12" style="padding-top:10px">
                        <div class="col-md-4">
                            <label class="control-label">品牌：</label>
                        </div>
                        <div class="col-md-8">
                            <label>{{edit.BrandCode}}</label>
                        </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                        <div class="col-md-4">
                            <label class="control-label">門市：</label>
                        </div>
                        <div class="col-md-8">
                            <label>{{edit.StoreCode + ' ' + edit.StoreName}}</label>
                        </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                        <div class="col-md-4">
                            <label class="control-label">平日營業時間：</label>
                        </div>
                        <div class="row col-md-8">
                            <!-- <div class='row mb-3'> -->
                                <div class='col-md-5'>
                                    <input type='time' class='form-control' v-model='edit.WeekdayStartTime'>
                                </div>
                                <label class='control-label'>至</label>
                                <div class='col-md-5'>
                                    <input type='time' class='form-control' v-model='edit.WeekdayEndTime'>
                                </div>
                            <!-- </div> -->
                            <!-- <input v-model="model.ProductionTime" type="text" placeholder="" class="form-control" /> -->
                            <div class="text-danger" v-if="valid_WeekdayTime">{{valid_WeekdayTime}}</div>
                        </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                        <div class="col-md-4">
                            <label class="control-label">假日營業時間：</label>
                        </div>
                        <div class="row col-md-8">
                            <!-- <div class='row mb-3'> -->
                                <div class='col-md-5'>
                                    <input type='time' class='form-control' v-model='edit.HolidayStartTime'>
                                </div>
                                <label class='control-label'>至</label>
                                <div class='col-md-5'>
                                    <input type='time' class='form-control' v-model='edit.HolidayEndTime'>
                                </div>
                            <!-- </div> -->
                            <!-- <input v-model="model.ProductionTime" type="text" placeholder="" class="form-control" /> -->
                            <div class="text-danger" v-if="valid_HolidayTime">{{valid_HolidayTime}}</div>
                        </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                        <div class="col-md-4">
                            <label class="control-label">備餐時間：</label>
                        </div>
                        <div class="col-md-8">
                            {{edit.ProductionTime}}
                        </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                        <div class="col-md-4">
                            <label class="control-label">臨時備餐時間：</label>
                        </div>
                        <div class="col-md-8">
                            {{edit.TempProductionTime}}
                        </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                        <div class="col-md-4">
                            <label class="control-label">臨時備餐最後修改時間：</label>
                        </div>
                        <div class="col-md-8" v-if="edit.TempProductionTimeUpdatedAt==null">
                        </div>
                        <div class="col-md-8" v-if="edit.TempProductionTimeUpdatedAt!==null">
                            {{edit.TempProductionTimeUpdatedAt | formatFullDate}}
                        </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                        <div class="col-md-4">
                            <label class="control-label">*本次更改是否取消預約單：</label>
                        </div>
                        <div class='col-md-8'>
                            <toggle-button v-model="edit.IsCancelAppointment" :height=30 :width=60
                            style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}"/>
                        </div>
                    </div>
                </div>
                <div class="cog-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn class="mt-3" variant="primary"  @click="editCheck()">儲存</b-btn>&nbsp;&nbsp;&nbsp;&nbsp;
                        <b-btn class="mt-3" variant="secondary"  @click="editCancel()">取消</b-btn>&nbsp;
                    </div>
                </div>
            </div>
        </b-modal>
      <!-- Delete Check Modal -->
      <b-modal ref="mdDelete" hide-footer :title="'刪除門市營業時間'">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">提醒您，<br /><b>當日</b>訂單須由<font style="color:red">人員手動執行退貨</font>；<br />
                <b>非當日</b>訂單由<font style="color:red">系統執行自動取消</font>。<br />確定刪除 {{delMsg}} 營業時間 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delWorkTime">確定</b-btn>
              <b-btn variant="secondary" @click="$refs.mdDelete.hide()">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
      <b-modal ref="mdCancelCheck" hide-footer title="取消訂單提醒">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">提醒您，<br /><b>當日</b>非營業時間訂單須由<font style="color:red">人員手動執行退貨</font>；<br />
                <span v-if="edit.IsCancelAppointment">
                  <b>非當日</b>且非營業時間的訂單由<font style="color:red">系統執行自動取消</font>。
                </span>
                <span v-else>
                  <b>非當日</b>且非營業時間的訂單<font style="color:red">將不會取消</font>。
                </span>
                <br />確定要修改營業時間 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="editConfirm()">確定</b-btn>
              <b-btn variant="secondary" @click="closeCancelCheck()">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script>

import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import { DEFAULT_SEARCH_BRAND_CODE } from '@/constants/defaultValues.js'
import miniToastr from 'mini-toastr'
import VModal from 'vue-js-modal'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
miniToastr.init()
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      API_URL: API_URL,
      FunctionPermission: 0,
      valid_errMsg: false,
      // 門店
      search: {
        brandCode: DEFAULT_SEARCH_BRAND_CODE,
        code: '',
        name: '',
        currentPage: 1,
      },
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      delMsg: '',
      edit: {
        BrandCode: '',
        ID: 0,
        StoreCode: '',
        StoreName: '',
        WeekdayStartTime: '',
        WeekdayEndTime: '',
        HolidayStartTime: '',
        HolidayEndTime: '',
        ProductionTime: '',
        TempProductionTime: '',
        TempProductionTimeUpdatedAt: '',
        IsCancelAppointment: true
      },
      valid_WeekdayTime: '',
      valid_HolidayTime: '',
      selectListBrands: []
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F20') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    this.querySelectListBrands();

    var search = this.$route.params.search
    if (search !== undefined) {
      if (search.name !== undefined) {
        this.search = search
        this.btnQuery()
      } else {
        this.reset()
      }
    } else {
      this.reset()
    }
  },
  methods: {
    reset () {
      this.search.code = ''
      this.search.name = ''
      this.search.brandCode = DEFAULT_SEARCH_BRAND_CODE

      this.btnQuery()
    },
    btnQuery () {
      this.search.currentPage = 1
      this.query()
    },
    query () {
      var brandcode, name, code, page, pageRows

        brandcode = this.search.brandCode
        name = this.search.name
        code = this.search.code
        page = this.search.currentPage
        pageRows = this.pageRows

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getStoreWorkTime/v1', {
        brandcode: brandcode,
        code: code,
        name: name,
        page: page,
        pageRows: pageRows
      })
        .then((response) => {
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.items = response.data.data
            this.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage = page // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.pageRows * (this.search.currentPage - 1) + 1;
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.pageRows > response.data.count) ? response.data.count : (this.search.currentPage * this.pageRows) >= response.data.count ? response.data.count : this.search.currentPage * this.pageRows;
            this.itemsByAllStoreSetting = response.data.dataByAllStore
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
        })
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    showDelete (item) {
      this.edit.ID = item.id
      this.delMsg = item.code + '-' + item.name
      this.$refs.mdDelete.show()
    },
    // 按下列表編輯按鈕
    editByOpen (item) {
      this.editClear()
      this.edit.BrandCode = item.brandCode
      this.edit.ID = item.id
      this.edit.StoreCode = item.code
      this.edit.StoreName = item.name
      this.edit.WeekdayStartTime = item.weekdayStartTime
      this.edit.WeekdayEndTime = item.weekdayEndTime
      this.edit.HolidayStartTime = item.holidayStartTime
      this.edit.HolidayEndTime = item.holidayEndTime
      this.edit.ProductionTime = item.productionTime
      this.edit.TempProductionTime = item.tempProductionTime
      this.edit.TempProductionTimeUpdatedAt = item.tempProductionTimeUpdatedAt
      this.edit.IsCancelAppointment = true
      this.$refs.mdEdit.show()
    },
    editCancel () {
      this.$refs.mdEdit.hide()
      this.editClear()
    },
    editClear () {
      this.edit.ID = 0
      this.edit.StoreCode = ''
      this.edit.StoreName = ''
      this.edit.WeekdayStartTime = ''
      this.edit.WeekdayEndTime = ''
      this.edit.HolidayStartTime = ''
      this.edit.HolidayEndTime = ''
      this.edit.ProductionTime = ''
      this.edit.TempProductionTime = ''
      this.edit.TempProductionTimeUpdatedAt = ''
    },
    checkTime(time) {
        if (time) {
            var lastStr = time.substr(-1)
            if (!(lastStr ==='0' || lastStr === '5')) {
                return false
            }
        } else {
            return false
        }
        return true
    },
    editConfirm () {
        this.$refs.mdCancelCheck.hide();
        this.valid_errMsg = false
        this.valid_WeekdayTime = ''
        this.valid_HolidayTime = ''
        if (this.edit.WeekdayStartTime !== '' || this.edit.WeekdayEndTime !== '' ) {
            if (this.edit.WeekdayStartTime === '' || this.edit.WeekdayEndTime === '') {
                this.valid_WeekdayTime = '請完整輸入時間起迄'
                this.valid_errMsg = true
            } else if (this.edit.WeekdayStartTime >= this.edit.WeekdayEndTime) {
                this.valid_WeekdayTime = '起不可大於等於迄'
                this.valid_errMsg = true
            } else if (!this.checkTime(this.edit.WeekdayStartTime) || !this.checkTime(this.edit.WeekdayEndTime)) {
                this.valid_WeekdayTime = '分鐘請以0或5結尾'
                this.valid_errMsg = true
            }
        }
        if (this.edit.HolidayStartTime !== '' || this.edit.HolidayEndTime !== '' ) {
            if (this.edit.HolidayStartTime === '' || this.edit.HolidayEndTime === '') {
                this.valid_HolidayTime = '請完整輸入時間起迄'
                this.valid_errMsg = true
            } else if (this.edit.HolidayStartTime >= this.edit.HolidayEndTime) {
                this.valid_HolidayTime = '起不可大於等於迄'
                this.valid_errMsg = true
            } else if (!this.checkTime(this.edit.HolidayStartTime) || !this.checkTime(this.edit.HolidayEndTime)) {
                this.valid_HolidayTime = '分鐘請以0或5結尾'
                this.valid_errMsg = true
            }
        }
        if (this.valid_errMsg) {
            this.$parent.verificationErrMsg()
            return
        }
        this.editSave()
    },
    editSave () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/updStoreWorkTime/v1', {
        id: this.edit.ID,
        weekdayStartTime: this.edit.WeekdayStartTime,
        weekdayEndTime: this.edit.WeekdayEndTime,
        holidayStartTime: this.edit.HolidayStartTime,
        holidayEndTime: this.edit.HolidayEndTime,
        isCancelAppointment: this.edit.IsCancelAppointment
      })
        .then((response) => {
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.query ()
            miniToastr.success('修改成功')
            this.editCancel ()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
        })
    },
    delWorkTime() {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/updStoreWorkTime/v1', {
        id: this.edit.ID,
        weekdayStartTime: '',
        weekdayEndTime: '',
        holidayStartTime: '',
        holidayEndTime: '',
        isCancelAppointment: this.edit.IsCancelAppointment
      })
        .then((response) => {
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.$refs.mdDelete.hide()
            this.query ()
            miniToastr.success('已刪除門市營業時間')
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
        })
    },
    editCheck() {
      this.$refs.mdCancelCheck.show();
    },
    closeCancelCheck() {
      this.$refs.mdCancelCheck.hide();
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: false
        })
        .then(response => {
          this.selectListBrands = response.data.data
          this.$parent.Loading = false
        })
        .catch(error => {
          this.selectListBrands = []
          this.$parent.Loading = false
          miniToastr.error(error, "資料讀取異常")
          console.log(error)
        })
    }
  },
  filters: {
    formatFullDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      var sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min + ':' + sec
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 320px;
  height: 270px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/ordersetting/StoreWorkTime.vue